export default __webpack_public_path__ + "static/media/sample_01.a4c807df.jpeg";